import { getSelectedSubclassId } from './subclasses/index.mjs';
import { getClassLevel } from './classIdentity.mjs';
import { isRageEffective } from './barbarianRage.mjs';
import { recklessWindow, resolveRecklessActorId, FRENZY_USED } from './recklessAttack.mjs';
export function barbarianSubclass(character) {
  return character?.classState?.barbarian?.subclassId || character?.classState?.barbarian?.subclass || getSelectedSubclassId(character, 'barbarian') || character?.subclasses?.barbarian || character?.barbarian?.subclass || null;
}
export function hasBerserkerFrenzy(character) {
  const subclass = barbarianSubclass(character);
  const id = String(subclass?.id ?? subclass?.key ?? subclass?.name ?? subclass ?? '').trim().toLowerCase();
  return getClassLevel(character, 'barbarian') >= 3 && ['berserker', 'path-of-the-berserker', 'path of the berserker'].includes(id);
}
export function frenzyDamageDice(character, combat, actorId, attack = {}) {
  actorId = resolveRecklessActorId(character, combat, actorId);
  const window = recklessWindow(combat, actorId);
  if (!hasBerserkerFrenzy(character) || !window.ownTurn || !window.active || !isRageEffective(character, combat, actorId)) return null;
  if (!['str', 'strength'].includes(String(attack.ability).toLowerCase()) || !['weapon', 'unarmed'].includes(attack.kind) || attack.hit !== true) return null;
  if ((combat.activeEffects || []).some(e => e.definitionId === FRENZY_USED && String(e.targetCombatantId) === actorId && e.turnSequence === combat.turnSequence)) return null;
  const level = getClassLevel(character, 'barbarian');
  return { label: 'Frenzy', count: level >= 16 ? 4 : level >= 9 ? 3 : 2, sides: 6 };
}
